import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, switchMap } from 'rxjs';
import { IonicModule } from '@ionic/angular';
import { PatchAdminUsersFiltersCommandHandler } from '../../../application/handlers';

@Component({
  selector: 'lib-users-filters',
  templateUrl: './users-filters.component.html',
  styleUrls: ['./users-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ReactiveFormsModule, IonicModule]
})
export class UsersFiltersComponent implements OnInit {
  private readonly destroyRef: DestroyRef = inject(DestroyRef);
  private readonly patchAdminUsersFiltersCommandHandler: PatchAdminUsersFiltersCommandHandler = inject(
    PatchAdminUsersFiltersCommandHandler
  );

  readonly searchForm: FormGroup = new FormGroup({
    search: new FormControl()
  });

  ngOnInit(): void {
    this.searchForm.valueChanges
      .pipe(
        debounceTime(2000),
        switchMap((search: { search: string }) =>
          this.patchAdminUsersFiltersCommandHandler.patch({
            search: search?.search
          })
        ),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
